import React, { PropTypes } from 'react'
import Helmet from 'react-helmet'
import { config } from 'config'
import Divider from '../components/Divider'
import Heading from '../components/Heading'
import LeadForm from '../components/LeadForm'
import Hero from '../components/Hero'
import CenterRow from '../components/CenterRow'
import AppsAndService from '../components/AppsAndService'
import AsyncImage from '../components/AsyncImage'

function ProjectsPage(props) {
	const pages = [ ...props.route.pages ]
	const path = props.route.page.path

	const meta = {
		description: "ACS acoustic cleaners (sonic horns) are effective in a wide range on industry applications including, but not limited too: SCR's, ESP's, Boilers, Fabric Filters, ID Fans, Dryers, Silos, and Hoppers. We service customers in several custom applications as well.",
		keywords: "Acoustic Cleaning Systems",
		headline: "ACS Applications: We have your application covered.",
		title: "ACS Applications: We have your application covered."
	}

	return (
		<div className="projects-page">
			<Helmet
				title={`${meta.title}`}
				meta={[
					{ name: "Description", content: `${meta.description}`},
					{ name: "Keywords", content: `${meta.keywords}`},
					{ property: "og:title", content: `${meta.headline}`},
					{ property: "og:description", content: `${meta.description}`},
					{ property: "og:type", content: "article"},
					{ property: "og:url", content: `${config.rootUrl}${path}`},
					{ name: "twitter:card", content: "summary_large_image"},
					{ name: "twitter:site", content: `${config.twitterHandle}` },
					{ name: "twitter:creator", content: `${config.twitterHandle}` },
					{ name: "twitter:title", content: `${meta.title}` },
					{ name: "twitter:description", content: `${meta.description}` }
				]}
			/>
			<Hero headline='Put Our Experience to Work for You.'
				className="applications"
				images={[
					'/images/hero/1.jpg',
					'/images/hero/2.jpg',
					'/images/hero/0.jpg',
				]}
			>
				<LeadForm />
			</Hero>
			<div className="container page">
				<br /><br />
				<CenterRow headline="Our horns are effective in numerous applications.">
					Acoustic cleaners provide an effective solution to buildup and
					material flow problems within a wide range of industries.
				</CenterRow>
				<Divider />
				<div className="row">
					<div className="col-md-12">
						<h2>SCR</h2>
					</div>
				</div>
				<div className="row">
					<div className="col-md-4 col-sm-6 col-xs-12">
						<AsyncImage src="/images/projects/SCR/SCR001.jpg" width={400} height={533} />
					</div>
					<div className="col-md-4 col-sm-6 col-xs-12">
						<AsyncImage src="/images/projects/SCR/SCR023.jpg" width={400} height={400} />
					</div>
					<div className="col-md-4 col-sm-6 col-xs-12">
						<AsyncImage src="/images/projects/SCR/SCR003.jpg" width={400} height={400} />
					</div>
					<div className="col-md-4 col-sm-6 col-xs-12">
						<AsyncImage src="/images/projects/SCR/SCR004.jpg" width={400} height={300} />
					</div>
					<div className="col-md-4 col-sm-6 col-xs-12">
						<AsyncImage src="/images/projects/SCR/SCR005.jpg" width={400} height={300} />
					</div>
					<div className="col-md-4 col-sm-6 col-xs-12">
						<AsyncImage src="/images/projects/SCR/SCR006.jpg" width={400} height={300} />
					</div>
					<div className="col-md-4 col-sm-6 col-xs-12">
						<AsyncImage src="/images/projects/SCR/SCR007.jpg" width={400} height={300} />
					</div>
					<div className="col-md-4 col-sm-6 col-xs-12">
						<AsyncImage src="/images/projects/SCR/SCR008.jpg" width={400} height={300} />
					</div>
					<div className="col-md-4 col-sm-6 col-xs-12">
						<AsyncImage src="/images/projects/SCR/SCR009.jpg" width={400} height={300} />
					</div>
					<div className="col-md-4 col-sm-6 col-xs-12">
						<AsyncImage src="/images/projects/SCR/SCR010.jpg" width={400} height={300} />
					</div>
					<div className="col-md-4 col-sm-6 col-xs-12">
						<AsyncImage src="/images/projects/SCR/SCR011.jpg" width={400} height={300} />
					</div>
					<div className="col-md-4 col-sm-6 col-xs-12">
						<AsyncImage src="/images/projects/SCR/SCR012.jpg" width={400} height={300} />
					</div>
					<div className="col-md-4 col-sm-6 col-xs-12">
						<AsyncImage src="/images/projects/SCR/SCR013.jpg" width={400} height={300} />
					</div>
					<div className="col-md-4 col-sm-6 col-xs-12">
						<AsyncImage src="/images/projects/SCR/SCR014.jpg" width={400} height={300} />
					</div>
					<div className="col-md-4 col-sm-6 col-xs-12">
						<AsyncImage src="/images/projects/SCR/SCR015.jpg" width={400} height={300} />
					</div>
					<div className="col-md-4 col-sm-6 col-xs-12">
						<AsyncImage src="/images/projects/SCR/SCR016.jpg" width={400} height={300} />
					</div>
					<div className="col-md-4 col-sm-6 col-xs-12">
						<AsyncImage src="/images/projects/SCR/SCR017.jpg" width={400} height={300} />
					</div>
					<div className="col-md-4 col-sm-6 col-xs-12">
						<AsyncImage src="/images/projects/SCR/SCR018.jpg" width={400} height={300} />
					</div>
					<div className="col-md-4 col-sm-6 col-xs-12">
						<AsyncImage src="/images/projects/SCR/SCR019.jpg" width={400} height={300} />
					</div>
					<div className="col-md-4 col-sm-6 col-xs-12">
						<AsyncImage src="/images/projects/SCR/SCR020.jpg" width={400} height={300} />
					</div>
					<div className="col-md-4 col-sm-6 col-xs-12">
						<AsyncImage src="/images/projects/SCR/SCR021.jpg" width={400} height={300} />
					</div>
					<div className="col-md-4 col-sm-6 col-xs-12">
						<AsyncImage src="/images/projects/SCR/SCR022.jpg" width={400} height={300} />
					</div>
					<div className="col-md-4 col-sm-6 col-xs-12">
						<AsyncImage src="/images/projects/SCR/SCR002.jpg" width={400} height={300} />
					</div>
				</div>				
				<Divider />
				<div className="row">
					<div className="col-md-12">
						<h2>ESP</h2>
					</div>
				</div>
				<div className="row">
					<div className="col-md-4 col-sm-6 col-xs-12">
						<AsyncImage src="/images/projects/ESP/ESP01.jpg" width={400} height={707} />
						{/* <p className="caption">A really important installation illustration.</p> */}
					</div>
					<div className="col-md-4 col-sm-6 col-xs-12">
						<AsyncImage src="/images/projects/ESP/ESP02.jpg" width={400} height={533} />
					</div>
					<div className="col-md-4 col-sm-6 col-xs-12">
						<AsyncImage src="/images/projects/ESP/ESP03.jpg" width={400} height={300} />
					</div>
				</div>
				<Divider />
				<div className="row">
					<div className="col-md-12">
						<h2>Other</h2>
					</div>
				</div>
				<div className="row">
					<div className="col-md-4 col-sm-6 col-xs-12">
						<AsyncImage src="/images/projects/Other/Other01.jpg" width={400} height={711} />
					</div>
					<div className="col-md-4 col-sm-6 col-xs-12">
						<AsyncImage src="/images/projects/Other/Other02.jpg" width={400} height={711} />
					</div>
					<div className="col-md-4 col-sm-6 col-xs-12">
						<AsyncImage src="/images/projects/Other/Other03.jpg" width={400} height={533} />
					</div>
					<div className="col-md-4 col-sm-6 col-xs-12">
						<AsyncImage src="/images/projects/Other/Other04.jpg" width={400} height={533} />
					</div>
					<div className="col-md-4 col-sm-6 col-xs-12">
						<AsyncImage src="/images/projects/Other/Other05.jpg" width={400} height={300} />
					</div>
				</div>
				<Divider />
				<AppsAndService />
			</div>
		</div>
	)
}

ProjectsPage.propTypes = {

}

ProjectsPage.defaultProps = {

}


ProjectsPage.data = {
  menuLabel: 'Projects',
	excludeFromMenu: true,
  menuShortDescription: 'Projects by Acoustic Cleaning Services, Inc.'
}

export default ProjectsPage



// WEBPACK FOOTER //
// ./projects.js